import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { MAX_PAGE_HEIGHT } from '../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  forgotPasswordWrapper: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    height: MAX_PAGE_HEIGHT,
  },
  forgotPasswordContentWrapper: {
    ...theme.mixins.appContainer,
    width: '480px',
    padding: theme.spacing(4, 2),

    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '100%',
      borderRadius: 0,
      display: 'flex',
      flexDirection: 'column',

      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  forgotPasswordForm: {
    width: '100%',
  },

  backToLogin: {
    textAlign: 'center',
    width: '100%',
    marginTop: '24px',
    fontWeight: 400,
    fontSize: '16px',
    color: theme.palette.font.secondary,
  },
  forgotPasswordSubmitButton: {
    marginTop: '32px',
  },
  backToLoginButton: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    marginLeft: '4px',
  },
  sentIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '16px',

    '& svg': {
      color: theme.palette.primary.main,
      fontSize: '96px',
    },
  },
}));
